export default __webpack_public_path__ + "static/bepower-7dfaa29a5c941bf05e19fd697fa1e636.png";